module.exports = __webpack_public_path__ + "img/palmar-hotel-2.2ee905f7.jpg";